/* eslint-disable max-len */
export const BOOTSTRAP_CDN = `https://stackpath.bootstrapcdn.com/bootstrap/\
4.4.1/css/bootstrap.min.css`;

export const BOOTSTRAP_INTIGRITY = `sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5\
TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh`;

export const GTM_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-528GLHDQ');`;

export const CLARITY_SCRIPT = ` (function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "j8uzonrnn0");`;

export const GTM_IFRAME_SRC = `https://www.googletagmanager.com/ns.html?\
id=${process.env.GTM_CONTAINER_ID}`;

export const WEBSITE_LOGO = `https://s3.ap-south-1.amazonaws.com/\
awign-production/website/images/meta-tag-logo.png`;

export const FONT_AWESOME_URL = `https://use.fontawesome.com/releases/v5.7.2/\
css/all.css`;

export const FONT_URL = `https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap`;

export const FONT_INTIGRITY = `sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7R\
rhN7udi9RwhKkMHpvLbHG9Sr`;

export const AWIGN_DESCRIPTION = `Discover endless career opportunities with Awign Experts! We connect talented individuals with 100+ leading companies, offering lucrative projects in as little as 72 hours. Unlock your potential with projects paying up to ₹42 lakhs and enjoy a steady stream of work. Join us today for a thriving career journey!`;

export const VIEWPORT_DESC = `width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no`;

export const ERROR_MSG = 'Sorry something went wrong!';

export const ERROR_MSG_401 = 'Your session has expired. Please login to continue.';

export const headTitlesMap = {
  '/privacy-policy': 'Awign Expert | Privacy Policy',
  '/terms-and-conditions': 'Awign Expert | Terms and Conditions',
  '/fraud-advisory': 'Awign Expert | Fraud Advisory'
};

export const GOOGLE_MAP_SCRIPT = `https://maps.googleapis.com/maps/api/js?\
v=3&key=AIzaSyAT2aU4rc0jz-MizPxYsJAMliE5LBS6pTA&libraries=places`;

export const GOOGLE_API_KEY = 'AIzaSyAT2aU4rc0jz-MizPxYsJAMliE5LBS6pTA';

export const FB_PIXEL_SCRIPT = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\
n.queue=[];t=b.createElement(e);t.async=!0;t.defer=!0;t.src=v;s=b.getElementsByTagName(e)[0];\
s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');\
fbq('init', ${process.env.FB_PIXEL_ID});\
fbq('track', 'PageView');
`;

export const COMPANY_CONSTITUTION_OPTIONS = [
  { label: 'Private Limited Company', value: 'private_ltd_company' },
  { label: 'Public Company', value: 'public_company' },
  { label: 'Sole Proprietorship', value: 'sole_proprietorship' },
  { label: 'One Person Company', value: 'one_person_company' },
  { label: 'Partnership', value: 'partnership' },
  { label: 'Limited Liability Partnership (LLP)', value: 'limited_liability_partnership' }
];

export const FAQsCandidate = [
  {
    Ques: 'Why Should I Join Awign Expert?',
    Ans: 'By joining Awign Expert, you can expect more than just a contract role. We strive to provide you with meaningful, full-time engagements that offer both professional growth and stability. Our lifelong rematching program enables you to build a successful and rewarding career with leading multinational companies. \n  \n With Awign Expert you don’t need to work on creating the best-suited resume or drafting a cover letter for each project application. We take care of all the hassles and bring the best opportunities to you to choose from.'
  },
  {
    Ques: 'What is the experience level required to apply for the jobs with Awign Expert?',
    Ans: 'The majority of jobs posted by our clients do require an experience of 2+ years. Therefore we recommended that you should have an experience of  3 years and above to apply for the jobs posted or signing up on our platform \n \n Changes from Project to Project basis - Look at all the open job roles to know more'
  },
  {
    Ques: 'What type of jobs does Awign Expert provide?',
    Ans: 'At Awign Expert, we offer a unique approach to contract roles that sets us apart. Our focus is on creating full-time, high-value engagements that are predominantly long-term, lasting approximately 12 months. Unlike traditional contract positions, we prioritize providing opportunities that are more substantial and rewarding.'
  },
  {
    Ques: 'What happens after I complete a project with Awign Expert?',
    Ans: `Once you successfully complete a project with us, we offer you lifelong rematching opportunities. This means you won't need to go through the vetting process again. Your work performance and previous results will be taken into account and added to your profile, allowing us to match you with your next project seamlessly. Our dedicated matching team works behind the scenes to rematch you with another leading multinational company.`
  },
  {
    Ques: 'How often do candidates get rematched with new projects?',
    Ans: 'We take pride in our high rematch rate, which stands at an impressive 95%! This means that our talented professionals consistently find new and exciting opportunities with top multinational companies.'
  },
  {
    Ques: 'What career growth opportunities I can get by working in a contractual job through Awign Expert?',
    Ans: 'Our commitment to lifelong rematching ensures that you can enjoy a continuous and fulfilling career path, leveraging your skills and expertise on long-term engagements.'
  }
];

export const whyAE = [
  {
    Title: 'Competitive pay for your efforts!',
    Desc: 'Earn more, work better'
  },
  {
    Title: 'Empower your interests',
    Desc: 'Choose your projects'
  },
  {
    Title: 'Expand your professional network',
    Desc: 'Boost your connections'
  },
  {
    Title: 'Level up your skills',
    Desc: 'Enhance your expertise and abilities'
  },
  {
    Title: 'Freelance for better payouts',
    Desc: 'Pay Income Tax for only half the Earnings'
  }
];

export const FAQsReferral = [
  {
    Ques: 'How does the Awign Expert referral program work?',
    Ans: 'You can earn ₹40,000 by inviting your friends to become an Awign Expert. \n You will receive ₹40,000 if your friend is selected for any job that is posted by Awign Expert.'
  },
  {
    Ques: 'How do I refer my friends?',
    Ans: '• Go to the Awign Expert referral Page. \n • Enter your friend’s mobile number and name \n • Click on Refer. Awign Expert will contact them through WhatsApp.\n • Track your friends’ progress.'
  },
  {
    Ques: 'How do I track progress?',
    Ans: 'You can track the referral status on this page: https://www.awignexpert.com/my-referrals'
  },
  {
    Ques: 'Can I refer my friends without signing up to the Awign Expert Platform?',
    Ans: `Yes, you can refer your friends to Awign Expert even without signing up yourself. In order to refer your friend without signing up: \n \n • Go to the Awign Expert referral Page. \n • Enter your friend’s mobile number and name \n • Enter your mobile number and name \n • Click on Continue to verify your mobile number \n • Enter OPT and verify your mobile number \n • Click on Refer. Awign Expert will contact your friend through WhatsApp. \n • You will be notified of your friend's progress through Whatsapp / SMS on the number you verified. \n • If your friend gets selected for any job within 3 Months of being referred, you will be asked to provide your Bank Details by making to exert@awign.com \n • You will receive the payment of ₹40,000 for each successful refferals`
  },
  {
    Ques: 'Is the referral repeatable?',
    Ans: 'Yes, the referral bonus is repeatable. Each time you refer and friend and they get selected for the job, you receive ₹40,000. \n \n For Eg: If you have 5 friends who meet the criteria for a Job. Refer them now. Once they get selected for the Job, you will receive a total of ₹2,00,000'
  }
];

export const FAQsVendor = [
  {
    Ques: 'Who are we?',
    Ans: 'Awign Expert is a pioneer in providing highly skilled contractual experts to a variety of clients, ranging from startups to established enterprises employing thousands of people. \n \n With such a diverse set of clients, we are able to provide multiple opportunities to our candidates as per their skillsets and requirements. \n \n Awign Expert provides a longer-term engagement and creates an environment of stability for our partners.'
  },
  {
    Ques: 'Where are our clients located?',
    Ans: 'We have a Worldwide focus and aim to provide onsite & remote candidates in the India and abroad.'
  },
  {
    Ques: 'What types of Jobs do we provide?',
    Ans: 'Unlike talent sourcing companies, Awign Expert does not provide freelancers or supply talents for an one-time fee. We provide our clients with project-based contractual talent, who works full-time for the assigned project, typically for a period of 12 Months as defined in the contract. \n \n We take care of the entire selection process and End to End execution of the candidates by onboarding them on our payroll or our partner’s payroll.'
  },
  {
    Ques: 'What is the commission structure for our Talent Supply Partners?',
    Ans: `We have a diverse commission structure rate that is tailored to the needs of our supply partners. The commission structure is decided on a case to case basis for each job role that is shared with our supply partners.`
  },
  {
    Ques: 'What happens at the End of a Contract, for candidates provided by our Talent Supply Partners?',
    Ans: 'At the End of a Contract, if the project is still in continuation the candidate could be asked to continue for next year. If the project has ended then we would help the candidate find another project suitable to their skills. \n \n In both cases, our partners would be receiving the commission as per the mutual agreement.'
  },
  {
    Ques: 'What career growth opportunities I can get by working in a contractual job through Awign Expert?',
    Ans: 'Our commitment to lifelong rematching ensures that you can enjoy a continuous and fulfilling career path, leveraging your skills and expertise on long-term engagements.'
  }
];

export const durationOptions = [
  { label: '1 month', value: 1 },
  { label: '2 months', value: 2 },
  { label: '3 months', value: 3 },
  { label: '4 months', value: 4 },
  { label: '5 months', value: 5 },
  { label: '6 months', value: 6 },
  { label: '7 months', value: 7 },
  { label: '8 months', value: 8 },
  { label: '9 months', value: 9 },
  { label: '10 months', value: 10 },
  { label: '11 months', value: 11 },
  { label: '12 months', value: 12 }
];
